import { FC } from 'react';

import { TTranslator } from '@smartshell/ui-kit';

import { TLocalesKeys } from 'localization';

import guestAvatarIcon from './assets/guest-avatar.svg';
import guestLoginIcon from './assets/guest-login.svg';
import s from './ShellRightSidebar.module.scss';

interface IShellRightSidebarProps {
  isGuest: boolean;
  t: TTranslator<TLocalesKeys>;
  onLogin?: () => void;
}

export const ShellRightSidebar: FC<IShellRightSidebarProps> = ({
  isGuest,
  t,
  onLogin,
}) => {
  if (!isGuest) return null;

  return (
    <section className={s.ssShellRightSidebar} aria-label={t('shell.profile')}>
      <div className={s.ssShellGuestProfile}>
        <div className={s.ssShellGuestProfileHeader}>
          <div className={s.ssShellGuestIdentity}>
            <div className={s.ssShellGuestAvatar} aria-hidden>
              <img src={guestAvatarIcon} alt="" />
            </div>
            <span className={s.ssShellGuestTitle}>
              {t('shell.guest.title')}
            </span>
          </div>
          <button
            className={s.ssShellGuestLoginButton}
            type="button"
            aria-label={t('shell.guest.login')}
            onClick={onLogin}
          >
            <img src={guestLoginIcon} alt="" aria-hidden />
          </button>
        </div>
        <p className={s.ssShellGuestCta}>{t('shell.guest.cta')}</p>
      </div>
    </section>
  );
};
